<template>
  <a-modal :visible="showDialog"  :mask="true" :maskClosable="false" :title="title" @ok="handleOk" @cancel="handleCancel()">
    <a-form layout="vertical">
      <a-form-item label="名称" >
        <a-input v-model="dataInfo.name" />
      </a-form-item>
      <a-form-item label="分类" >
        <a-select v-model="dataInfo.type_id" :maxTagCount="1" placeholder="请选择分类" optionFilterProp="label" show-search>
          <a-select-option v-for="item in typeList" :label="item.name" :value="item.id"
            :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="键名">
        <a-input v-model="dataInfo.key" />
      </a-form-item>
      <a-form-item label="键值">
        <a-input v-model="dataInfo.value" />
      </a-form-item>
      <a-form-item label="备注">
        <a-textarea :rows="4" v-model="dataInfo.remarks"  />
      </a-form-item>
      
    </a-form>
  </a-modal>
</template>
<script>
import { ConfigSave } from "../../api/v1/config_api";

export default {
  name: "ConfigEditDialog",
  props: ['showDialog','dataInfo','title','typeList'],
  data() {
    return {
    }
  },
  methods: {
    handleOk() {
      if (!this.dataInfo.name) {
        this.$message.error('请输入配置名称')
        return
      }
      if (!this.dataInfo.key) {
        this.$message.error('请输入键名')
        return
      }
      if (!this.dataInfo.value) {
        this.$message.error('请输入键值')
        return
      }
      ConfigSave(this.dataInfo).then(resp => {
        if (resp.code === 200) {
          this.$message.success(resp.msg)
          this.$emit('close-dialog')
        } else {
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel() {
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/V1/ConfigEditDialog.vue